var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "wrapper row no-margin",
      staticStyle: { height: "100%", display: "flow-root" }
    },
    [
      _c("header", { staticClass: "row align-items-center no-margin" }, [
        _c("div", { staticClass: "col" }, [
          _c(
            "button",
            {
              staticClass: "btn no-bg",
              on: {
                click: function($event) {
                  return _vm.setPosSection("choose-product")
                }
              }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 mt-3 mb-1 status" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("message.diningoptions")) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "col-12 no-padding items" },
        [
          _vm.diningName
            ? _c(
                "li",
                {
                  staticClass: "row no-margin item text-danger",
                  on: {
                    click: function($event) {
                      return _vm.onDeselectDining()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _c("i", {
                      staticClass: "fas fa-ban",
                      staticStyle: {
                        "margin-right": "7px",
                        "margin-left": "3px",
                        "font-size": "13px"
                      }
                    }),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("message.deselected")) +
                        "\n      "
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.diningOptions, function(item, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "row no-margin item",
                on: {
                  click: function($event) {
                    return _vm.onSelectDining(item.name)
                  }
                }
              },
              [
                _c("div", { staticClass: "col container-dining" }, [
                  _c("div", { staticClass: "dining-icon" }, [
                    _c("i", { class: [item.icon] })
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("\n          " + _vm._s(item.text) + "\n        ")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col text-right" })
              ]
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-47da1524", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47da1524","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/include/DiningList.vue
// module id = null
// module chunks = 